/**
 * Major football leagues with good odds coverage
 * These leagues typically have both pre-match and live odds available
 */

export const MAJOR_LEAGUES = {
  // Europe - Top 5
  PREMIER_LEAGUE: { id: 39, name: 'Premier League', country: 'England' },
  LA_LIGA: { id: 140, name: 'La Liga', country: 'Spain' },
  SERIE_A: { id: 135, name: 'Serie A', country: 'Italy' },
  BUNDESLIGA: { id: 78, name: 'Bundesliga', country: 'Germany' },
  LIGUE_1: { id: 61, name: 'Ligue 1', country: 'France' },
  
  // Europe - Additional
  EREDIVISIE: { id: 88, name: 'Eredivisie', country: 'Netherlands' },
  PRIMEIRA_LIGA: { id: 94, name: 'Primeira Liga', country: 'Portugal' },
  CHAMPIONSHIP: { id: 40, name: 'Championship', country: 'England' },
  
  // International
  CHAMPIONS_LEAGUE: { id: 2, name: 'UEFA Champions League', country: 'World' },
  EUROPA_LEAGUE: { id: 3, name: 'UEFA Europa League', country: 'World' },
  WORLD_CUP: { id: 1, name: 'World Cup', country: 'World' },
  
  // Americas
  MLS: { id: 253, name: 'Major League Soccer', country: 'USA' },
  USL_LEAGUE_ONE: { id: 489, name: 'USL League One', country: 'USA' }, // Added for testing live odds
  LIGA_MX: { id: 262, name: 'Liga MX', country: 'Mexico' },
  BRASILEIRAO_A: { id: 71, name: 'Serie A', country: 'Brazil' },
  BRASILEIRAO_B: { id: 72, name: 'Serie B', country: 'Brazil' },
  BRASILEIRAO_C: { id: 75, name: 'Serie C', country: 'Brazil' },
  BRASILEIRAO_D: { id: 76, name: 'Serie D', country: 'Brazil' },
  COPA_LIBERTADORES: { id: 13, name: 'Copa Libertadores', country: 'World' },
  
  // Other Popular
  SUPER_LIG: { id: 203, name: 'Super Lig', country: 'Turkey' },
  RUSSIAN_PREMIER: { id: 235, name: 'Premier League', country: 'Russia' },
  J_LEAGUE: { id: 98, name: 'J1 League', country: 'Japan' },
  A_LEAGUE: { id: 188, name: 'A-League', country: 'Australia' },
};

// Get league IDs for major leagues
export const MAJOR_LEAGUE_IDS = Object.values(MAJOR_LEAGUES).map(league => league.id);

// Leagues most likely to have live odds
export const LIVE_ODDS_PRIORITY_LEAGUES = [
  39,  // Premier League
  140, // La Liga  
  135, // Serie A
  78,  // Bundesliga
  61,  // Ligue 1
  2,   // Champions League
  3,   // Europa League
  253, // MLS
  262, // Liga MX
  71,  // Brasileirao A
];

// Helper function to check if a league is major
export const isMajorLeague = (leagueId) => {
  return MAJOR_LEAGUE_IDS.includes(Number(leagueId));
};

// Helper to get league info
export const getLeagueInfo = (leagueId) => {
  return Object.values(MAJOR_LEAGUES).find(league => league.id === Number(leagueId));
};

export default MAJOR_LEAGUES;